export default __webpack_public_path__ + "static/media/phone hover_motorola-motoe-black-portrait.23e66ed7.png";